import { IconWrapper } from '../runtime';
export default IconWrapper('locate', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M14 6.99976C14 10.5996 9.12316 14.211 8.16299 14.8871C8.06382 14.9569 7.93618 14.9569 7.83701 14.8871C6.87684 14.211 2 10.5996 2 6.99976C2 3.68605 4.68629 0.999756 8 0.999756C11.3137 0.999756 14 3.68605 14 6.99976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M10.5 6.99976C10.5 8.38047 9.38071 9.49976 8 9.49976C6.61929 9.49976 5.5 8.38047 5.5 6.99976C5.5 5.61904 6.61929 4.49976 8 4.49976C9.38071 4.49976 10.5 5.61904 10.5 6.99976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});